import React, { useContext, useEffect, useState } from "react";
import { Breadcrumb, Button, Card, Col, Form, Row } from "react-bootstrap";
import Layout from '../../layout/Layout';
import { Link, useNavigate, useParams } from "react-router-dom";
import { getCountry, getServiceProvider, addVpn, getViewVPN } from "./service";
import { toast } from "react-toastify";
import { AuthContext } from "../../AppContext";
import { SelectPicker } from "rsuite";
import CreatableSelect from 'react-select/creatable';
import { setInlineStyles } from "rsuite/esm/List/helper/utils";


const VPNAdd = () => {
    const { id } = useParams();
    const navigate = useNavigate()
    const { userPermission, token } = useContext(AuthContext)

    const [iaLoading, setIsLoading] = useState(false)
    const [servicesProvider, setServiceProvider] = useState([])
    const [allCountry, setAllCountry] = useState([])
    const [selectedCountry, setSelectedCountry] = useState([])
    const [payload, setPayLoad] = useState([])
    const [deletedData, setDeletedData] = useState({
        country: [],
        countryData: []
    })
    const [data, setData] = useState(null)
    const [validated, setValidated] = useState(false);
    const uuid = () => {
        const uuid = Math.random().toString(36).slice(-6);
        return uuid
    }

    const fetchServiceProvider = async () => {
        setIsLoading(true)
        try {
            const response = await getServiceProvider({}, token)
            if (response?.status) {
                setServiceProvider(response?.data?.map((item) => { return { value: item?.id, label: item?.name } }))
            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setIsLoading(false)
        }
    }

    const fetchCountry = async () => {
        setIsLoading(true)
        try {
            const response = await getCountry({}, token)
            if (response?.status) {
                setAllCountry(response?.data?.map((item) => { return { value: item?.id, label: item?.name } }))
            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setIsLoading(false)
        }
    }
    const fetchVPN = async () => {
        setIsLoading(true)
        try {
            const formData = new FormData()
            formData?.append("id", id)
            const response = await getViewVPN(formData, token)
            if (response?.status) {
                setData(response?.data)
            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setIsLoading(false)
        }
    }
    /** Change Provider */
    const handleChangeProvider = (name) => {
        setData({
            "name": name,
            "status": 0,
            "countries": [
                {
                    "name": "",
                    "status": 0,
                    "country_data": [
                        {
                            "new_id": uuid(),
                            "country_id": "",
                            "ip": "",
                            "certificate": "",
                            "user": "",
                            "status": 0,
                            "password": "",
                        }

                    ]
                },]
        });
    };
    /**add Country */
    const handleAddCountry = () => {
        setData((pre) => {
            const add = { ...pre };
            add.countries = [...(add.countries || []), {
                "name": "",
                "service_provider_id": data.id,
                "country_data": [
                    {
                        "new_id": uuid(),
                        "country_id": "",
                        "ip": "",
                        "certificate": "",
                        "user": "",
                        "status": 0,
                        "password": "",
                    }]
            }];
            return add;
        });
    }
    /**remove Country */
    const handleRemoveCountry = (index, id) => {
        if (id) {
            setDeletedData((prev) => ({
                ...prev,
                country: [...(prev.country || []), id]
            }));
        }
        setData((pre) => {
            const add = { ...pre };
            add.countries = add.countries.filter((_, ind) => ind !== index);
            return add;
        });

    };

    /**add Country Data*/
    const handleAddCountryData = (index) => {
        setData((pre) => {
            const add = { ...pre };
            const updatedCountries = [...add.countries];
            const updatedCountryData = [...(updatedCountries[index]?.country_data || [])];
            updatedCountryData.push({
                "new_id": uuid(),
                "country_id": "",
                "ip": "",
                "certificate": "",
                "user": "",
                "status": 0,
                "password": "",
            });
            updatedCountries[index] = {
                ...updatedCountries[index],
                country_data: updatedCountryData,
            };
            add.countries = updatedCountries;

            return add;
        });
    };

    /** Remove Country Data */
    const handleRemoveCountryData = (index, i, id) => {
        if (id) {
            setDeletedData((prev) => ({
                ...prev,
                countryData: [...(prev.countryData || []), id]
            }));
        }
        setData((pre) => {
            const remove = { ...pre };
            const updatedCountries = [...remove.countries];
            const updatedCountryData = updatedCountries[index]?.country_data.filter((_, ind) => ind !== i) || [];
            updatedCountries[index] = {
                ...updatedCountries[index],
                country_data: updatedCountryData,
            };
            remove.countries = updatedCountries;

            return remove;
        });
    };



    /** handle Change input values*/
    const handleChangeCountry = (value, index, field) => {
        setData((pre) => {
            const add = { ...pre };
            const updatedCountries = [...add.countries];
            updatedCountries[index] = {
                ...updatedCountries[index],
                [field]: value
            };
            add.countries = updatedCountries;

            return add;
        });
    };

    const handleChange = (value, index, i, field) => {
        setData((pre) => {
            const add = { ...pre };
            const updatedCountries = [...add.countries];
            const updatedCountryData = [...(updatedCountries[index]?.country_data || [])];
            updatedCountryData[i] = {
                ...updatedCountryData[i],
                [field]: value
            };
            updatedCountries[index] = {
                ...updatedCountries[index],
                country_data: updatedCountryData
            };
            add.countries = updatedCountries;

            return add;
        });
    };

    const handleDefaultImage = (e, newId, id, group_id) => {
        if (newId) {
            setPayLoad({ ...payload, [`new_certificate_${newId}`]: e.target.files[0] })
            // setSelectedImage({
            //     ...selectedImage,
            //     defaultAffiliationImage: {
            //         ...selectedImage.defaultAffiliationImage,
            //         [group_id]: e.target.files[0].name,
            //     },
            // });
        } else {
            setPayLoad({ ...payload, [`certificate_${id}`]: e.target.files[0] })
            // setSelectedImage({
            //     ...selectedImage,
            //     defaultAffiliationImage: {
            //         ...selectedImage.defaultAffiliationImage,
            //         [group_id]: e.target.files[0].name,
            //     },
            // });
        }
    };
    console.log('data?.countries?.every((item)=>item?.name)', data?.countries?.every((item) => item?.name))
    /**Save the service data  */
    const handleSubmit = async (event) => {
        setValidated(true)
        const form = event.currentTarget;
        event.preventDefault();

        if (form.checkValidity() === false || !data?.countries?.every((item) => item?.name)) {
            event.stopPropagation();
        } else {
            setValidated(true);
            try {
                const formData = new FormData()
                formData?.append("insertData", JSON.stringify(data))
                deletedData?.country?.length > 0 && formData?.append("DeletedCountries", deletedData?.country?.toString())
                deletedData?.countryData?.length > 0 && formData?.append("DeletedCountryData", deletedData?.countryData?.toString())
                for (const key in payload) {
                    if (payload.hasOwnProperty(key)) {
                        formData?.append(key, payload[key])
                    }
                }
                const response = await addVpn(formData, token)
                if (response?.status) {
                    if (id) {
                        toast.success("Services Update successfully");
                        navigate(`/vpn/view/${id}`)
                    } else {
                        toast.success("Services Add successfully");
                        navigate(`/vpn`)

                    }
                }
            } catch (error) {
                console.error('An error occurred:', error);
            }
        }
    };

    useEffect(() => {
        setSelectedCountry(
            data?.countries?.map((el) => { return el.name })
        )
    }, [data])

    useEffect(() => {
        fetchServiceProvider()
        fetchCountry()
        id && fetchVPN()
    }, [])
    return (
        <Layout sidebar={true}>
            <div className="page-heading">
                <h3>VPN {id ? "Edit" : "Add"}</h3>
                <Breadcrumb className="d-none d-sm-none d-md-none d-lg-block">
                    <Breadcrumb.Item >
                        <Link to="/"><i className='bx bx-home-alt me-2 fs-5' ></i> Home</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item >
                        <Link to="/vpn">VPN</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>VPN {id ? "Edit" : "Add"}</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="page-content">
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Card className="mb-4 radiustop-0">
                        <Card.Body>
                            <Row className="g-4">
                                <Col md={4}>
                                    <Form.Label htmlFor="sp">Service Provider</Form.Label>
                                    <CreatableSelect isClearable
                                        options={servicesProvider}
                                        onChange={(e) => handleChangeProvider(e.label)}
                                        // defaultValue={{ label: el.utm_term, value: el.utm_term }}
                                        value={{ label: data?.name, value: data?.id }}
                                        isDisabled={id}
                                        placeholder="Select Service Provider"
                                        className={`customMulSelect my-2`}
                                        classNamePrefix="react-select"
                                    />
                                </Col>
                                {data?.name && <Col md={8} className="text-end align-self-end">
                                    <Button onClick={handleAddCountry} variant="primary">Add</Button>
                                </Col>}
                                {data?.countries?.length > 0 && data?.countries?.map((item, index) => {
                                    return (<Col md={12} key={index}>
                                        <Card className="border">
                                            <Card.Body>
                                                <Row className="g-4">
                                                    <Col md={4}>
                                                        <Form.Label htmlFor="sp">Country</Form.Label>
                                                        <CreatableSelect isClearable
                                                            options={allCountry?.filter((el) => !selectedCountry?.includes(el.label))}
                                                            value={allCountry?.find((el) => el?.label == item?.name)}
                                                            // isDisabled
                                                            onChange={(e) => handleChangeCountry(e.label, index, 'name')}
                                                            // defaultValue={{ label: el.utm_term, value: el.utm_term }}
                                                            placeholder="Select Country"
                                                            className={`customMulSelect my-2 ${validated && !item?.name ? "rs-novalidated" : ""}`}
                                                            classNamePrefix="react-select"
                                                        />
                                                        {validated && !item?.name && <div className="invalid-feedback d-block">
                                                            Country Name Field Is Require
                                                        </div>}
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label htmlFor="status" className="d-block mb-2">
                                                            Status
                                                        </Form.Label>

                                                        <Form.Check
                                                            type="switch"
                                                            onChange={(e) => handleChangeCountry(e?.target?.checked ? 1 : 0, index, "status")}
                                                            name="status"
                                                            checked={item?.status === 1 ? true : false}
                                                        />
                                                    </Col>
                                                    <Col md={4} className="text-end align-self-end mb-2">
                                                        <Button variant="danger btn-icon me-3" onClick={() => handleRemoveCountry(index, item?.id && item?.id)}><i className="bx bx-x"></i></Button>
                                                        <Button variant="primary" onClick={() => handleAddCountryData(index)}>Add</Button>
                                                    </Col>
                                                </Row>
                                                {item?.country_data?.length > 0 && item?.country_data?.map((countryData, i) => {
                                                    return (
                                                        <React.Fragment key={i}>
                                                            <hr />
                                                            <Row>
                                                                <Col md={4}>
                                                                    <Form.Label>IP</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="name"
                                                                        className="my-2"
                                                                        onChange={(e) => handleChange(e?.target?.value, index, i, "ip")}
                                                                        value={countryData?.ip}
                                                                        required
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Service Name Field Is Require
                                                                    </Form.Control.Feedback>
                                                                </Col>
                                                                <Col md={4}>
                                                                    <Form.Label>Certificate</Form.Label>
                                                                    <Form.Control
                                                                        type="file"
                                                                        name="name"
                                                                        accept=".ovpn"
                                                                        className="my-2"
                                                                        onChange={(e) => handleDefaultImage(e, countryData?.new_id && countryData?.new_id, countryData?.id && countryData?.id, item?.id)}                                                                        // value={servicesProvider?.name}
                                                                        required={!countryData?.certificate}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Certificate Name Field Is Require
                                                                    </Form.Control.Feedback>
                                                                </Col>
                                                                <Col md={2}>
                                                                    <Form.Label htmlFor="status" className="d-block mb-2">
                                                                        Status
                                                                    </Form.Label>

                                                                    <Form.Check
                                                                        type="switch"
                                                                        onChange={(e) => handleChange(e?.target?.checked ? 1 : 0, index, i, "status")}
                                                                        name="status"
                                                                        checked={countryData?.status === 1 ? true : false}
                                                                    />
                                                                </Col>
                                                                <Col md={2} className="text-end align-self-center">
                                                                    {item?.country_data?.length > 1 && <Button variant="danger btn-icon mb-1" onClick={() => handleRemoveCountryData(index, i, countryData?.id && countryData?.id)}><i className="bx bx-x"></i></Button>}
                                                                </Col>
                                                                <Col md={4}>
                                                                    <Form.Label>User ID</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="name"
                                                                        className="my-2"
                                                                        onChange={(e) => handleChange(e?.target?.value, index, i, "user")}
                                                                        value={countryData?.user}
                                                                        required
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Certificate Name Field Is Require
                                                                    </Form.Control.Feedback>
                                                                </Col>
                                                                <Col md={4}>
                                                                    <Form.Label>Password</Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="name"
                                                                        className="my-2"
                                                                        onChange={(e) => handleChange(e?.target?.value, index, i, "password")}
                                                                        value={countryData?.password}
                                                                        required
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        Certificate Name Field Is Require
                                                                    </Form.Control.Feedback>
                                                                </Col>
                                                            </Row>
                                                        </React.Fragment>)
                                                })}
                                                {/* <hr />
                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Label>IP</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            className="my-2"
                                                            // onChange={(e) => handleChange(e?.target?.value, "name")}
                                                            // value={servicesProvider?.name}
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Service Name Field Is Require
                                                        </Form.Control.Feedback>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label>Certificate</Form.Label>
                                                        <Form.Control
                                                            type="file"
                                                            name="name"
                                                            className="my-2"
                                                            // onChange={(e) => handleChange(e?.target?.value, "name")}
                                                            // value={servicesProvider?.name}
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Certificate Name Field Is Require
                                                        </Form.Control.Feedback>
                                                    </Col>
                                                    <Col md={2}>
                                                        <Form.Label htmlFor="status" className="d-block mb-2">
                                                            Status
                                                        </Form.Label>

                                                        <Form.Check
                                                            type="switch"
                                                            onChange={(e) => handleChange(e?.target?.checked ? 1 : 0, "status")}
                                                            name="status"
                                                            checked={servicesProvider?.status === 1 ? true : false}
                                                        />
                                                    </Col>
                                                    <Col md={2} className="text-end align-self-center">
                                                        <Button variant="danger btn-icon mb-1"><i className="bx bx-x"></i></Button>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label>User ID</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            className="my-2"
                                                            // onChange={(e) => handleChange(e?.target?.value, "name")}
                                                            // value={servicesProvider?.name}
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Certificate Name Field Is Require
                                                        </Form.Control.Feedback>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Label>Password</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="name"
                                                            className="my-2"
                                                            // onChange={(e) => handleChange(e?.target?.value, "name")}
                                                            // value={servicesProvider?.name}
                                                            required
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            Certificate Name Field Is Require
                                                        </Form.Control.Feedback>
                                                    </Col>

                                                </Row> */}
                                            </Card.Body>
                                        </Card>
                                    </Col>)
                                })}
                            </Row>
                        </Card.Body>
                        <Card.Footer className="text-end">
                            <Button variant="primary" type="submit" className="me-3">Save</Button>
                            <Link to={id ? `/vpn/view/${id}` : `/vpn`}>
                                <Button variant="secondary">Cancel</Button>
                            </Link>
                        </Card.Footer>
                    </Card>
                </Form>
            </div>
        </Layout>
    )
}

export default VPNAdd